module.exports = __webpack_public_path__ + "img/Logo_ined.ffc52e3b.svg";